import Box from '@zenbusiness/zui/Box';
import Heading from '@zenbusiness/zui/Heading';
import SharedAsset from '@zenbusiness/zui/SharedAsset';
import { styled } from '@zenbusiness/zui/styles';

const TitleStyle = ({ theme }) => ({
  marginBottom: '12px',
  [theme.breakpoints.up('md')]: {
    marginBottom: '16px'
  }
});

const ImageStyle = () => ({
  width: '100%'
});

const ImageWrapperStyle = () => ({
  gridColumn: '1 / 5',
  width: '100%'
});

const ContentWrapperStyle = ({ theme }) => ({
  gridColumn: '1 / 5',
  [theme.breakpoints.up('sm')]: {
    gridColumn: '1 / 7'
  },
  [theme.breakpoints.up('md')]: {
    gridColumn: '6 / 13'
  }
});

export const ImageStyled = styled(SharedAsset)(ImageStyle);
export const HeadingStyled = styled(Heading)(TitleStyle);
export const ImageWrapperStyled = styled(Box)(ImageWrapperStyle);
export const ContentWrapperStyled = styled(Box)(ContentWrapperStyle);
